"use client";
import { useState } from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { Community } from "@prisma/client";
import EventProposeModal from "~/components/v3/modals/ProposeEventModal";
import { Button } from "~/components/v3/themed/Button";
import { UserPermissions } from "~/server/api/helpers/permissionHelpers";

type SimpleCommunity = Pick<
    Community,
    | "id"
    | "name"
    | "slug"
    | "image"
    | "defaultTags"
    | "forceUseOfTemplatedEvent"
    | "customBanner"
> & {
    hostRequiredData?: PrismaJson.HostRequiredData | null;
};

type Props = {
    community: SimpleCommunity;
    permissions: UserPermissions;
    label?: string;
    asLink?: boolean;
};
const HostAnEventButton = ({
    community,
    permissions,
    label = "Host an event",
    asLink = false,
}: Props) => {
    const [open, setOpen] = useState(false);
    const searchParams = useSearchParams();
    const router = useRouter();
    const pathname = usePathname();

    const conditionType = community.customBanner?.conditionType;

    const handleClick = () => {
        if (community.slug === "shipaton") {
            const params = new URLSearchParams(searchParams?.toString() || "");
            params.set("proposeEvent", "true");
            router.replace(`${pathname}?${params.toString()}`);
        } else {
            setOpen(true);
        }
    };

    if (conditionType === "membership" && !permissions.isMember) {
        return null;
    }

    return (
        <>
            {!asLink ? (
                <Button
                    onClick={handleClick}
                    variant="secondary"
                    className={`
                    w-[120px]
                    px-1
                    transition-shadow duration-700
                    hover:shadow-[2px_6px_50px_10px_#D822F9C8]
                `}
                >
                    {label}
                </Button>
            ) : (
                <button
                    className="w-max text-white underline hover:text-v3-N-200"
                    onClick={handleClick}
                >
                    {label}
                </button>
            )}

            <EventProposeModal
                community={community}
                setOpen={setOpen}
                open={open}
                hasManagingPermissions={
                    permissions.isManager || permissions.isAdmin
                }
            />
        </>
    );
};

export default HostAnEventButton;
